import React from "react";
import { ASSIGNED_TASKS, MyTasksListKey, TaskNote } from "../../../redux/myTasks";
import TaskCheckbox from "./TaskCheckbox";
import TaskAssigneeAvatar from "./TaskAssigneeAvatar";

export interface TaskLeadingControlProps {
  tab: MyTasksListKey;
  note: TaskNote;
  complete: boolean;
  onToggleComplete: (noteId: string, complete: boolean) => void;
}

/**
 * Your Tasks gets an editable checkbox (it's your own task to complete);
 * Assigned Tasks - the assigner's read-only view onto someone else's task -
 * gets an avatar for who it's assigned to instead.
 */
const TaskLeadingControl = ({ tab, note, complete, onToggleComplete }: TaskLeadingControlProps) => {
  if (tab === ASSIGNED_TASKS) {
    return <TaskAssigneeAvatar note={note} />;
  }

  return (
    <TaskCheckbox
      checked={complete}
      onChange={(nextComplete) => onToggleComplete(note.note_id, nextComplete)}
      label="Mark task complete"
    />
  );
};

export default TaskLeadingControl;
